import { render, staticRenderFns } from "./DeletePend.vue?vue&type=template&id=466bdc74&scoped=true"
import script from "./DeletePend.vue?vue&type=script&lang=js"
export * from "./DeletePend.vue?vue&type=script&lang=js"
import style0 from "./DeletePend.vue?vue&type=style&index=0&id=466bdc74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466bdc74",
  null
  
)

export default component.exports